<template>
  <div class="header">
    <div class="cont">
      <div class="logo">
        <img src="@/assets/images/tlog.jpg" alt="LOGO"/>
      </div>
      <div class="tel">
        <img src="@/assets/images/hr.gif" alt="TEL" />
      </div>

      <div class="top clear">
        <img src="@/assets/images/hi.jpg" alt="hi.jpg" />
      </div>
      <router-link to="/home" class="btnHome"></router-link>
      <router-link to="/news" class="btnNews"></router-link>
      <router-link to="/service" class="btnService"></router-link>
      <router-link to="/about" class="btnComp"></router-link>
      <div class="btnTmp"></div>
    </div>
  </div>
</template>
<script>
export default {
  setup() {
    return {};
  },
};
</script>